export default ({ name }) => {
  const url = new URL(global.location);
  url.searchParams.delete(name);
  global.history.replaceState({}, '', url);
};
